"use client";

import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Link from "next/link";
import Cookies from "js-cookie";
import styles from "./welcome-popup.module.scss";

const COOKIE_KEY = "ai2peat_welcome_popup_dismissed";
const COOKIE_EXPIRY_DAYS = 365;
const SHOW_DELAY_MS = 900;

export default function WelcomePopup() {
  const [show, setShow] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const dismissed = Cookies.get(COOKIE_KEY) === "true";
    if (dismissed) return;

    const timer = setTimeout(() => setShow(true), SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    if (dontShowAgain) {
      Cookies.set(COOKIE_KEY, "true", {
        expires: COOKIE_EXPIRY_DAYS,
        sameSite: "lax",
        path: "/",
      });
    }
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName={styles.dialog}
      contentClassName={styles.modalContent}
    >
      <div className={styles.popup}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>

        <span className={styles.eyebrow}>New here?</span>
        <h2 className={styles.title}>See what PeatSense can do, in two minutes.</h2>
        <p className={styles.body}>
          AI2Peat turns satellite and sensor data into peatland condition
          insights, at any scale. The fastest way to see it for yourself is
          our interactive demo: pick a service, click an area on the map,
          and see a real, already-computed result. No sign up needed.
        </p>

        <Link href="/demo" className={styles.ctaBtn} onClick={handleClose}>
          Try the live demo
        </Link>

        <button type="button" className={styles.laterBtn} onClick={handleClose}>
          Maybe later
        </button>

        <label className={styles.checkboxRow}>
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          />
          Don&apos;t show this again
        </label>
      </div>
    </Modal>
  );
}
